import styled from 'styled-components';
import { Col, Collapse } from 'antd';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

export const ScoreComponent = styled.div`
	background-color: rgb(234, 238, 253);
	border: 2px solid ${DEFAULT_RISK_RPN_COLOR};
	width: 80px;
	height: 35px;
	border-radius: 0.5rem;
`;

export const ScoreText = styled.h2`
	color: ${DEFAULT_RISK_RPN_COLOR};
	font-weight: bold;
	text-align: center;
`;

export const SectionContainer = styled.div`
	margin-top: 1rem;
	background-color: #f8f8f8;
	padding: 1.5rem;
	padding-bottom: 0.3rem;
	border-radius: 1rem;
`;

export const DescriptionElement = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1rem;
	background-color: #fff;
	border-radius: 0.5rem;
	padding: 0.1rem;
	border: 2px solid #ebebeb;
	width: '100%';
`;

export const RightAlignedElement = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 1rem;
	background-color: #fff;
	border-radius: 0.5rem;
	padding: 0.1rem;
	border: 2px solid #ebebeb;
	width: 12rem !important;
`;

export const DurationScoreCol = styled(Col)`
	border-left: 2px solid #ebebeb;
	text-align: center;
	margin-right: 10px;
	h3 {
		display: flex;
		justify-content: center;
	}
	@media (max-width: 1600px) {
		margin-right: -8px;
	}
	@media (max-width: 1200px) {
		margin-right: -12px;
	}
`;

export const DurationLabel = styled.h3`
	margin-top: 0.5rem;
	text-align: left;
	margin-left: 0.5rem;
`;

export const ElementDescription = styled.h3`
	margin-top: 0.5rem;
	margin-left: 0.5rem;
`;

export const ElementStyledCol = styled(Col)`
	border-left: 2px solid #ebebeb;
	text-align: center;
`;

export const StyledCollapse = styled(Collapse)`
	.ant-collapse-item > .ant-collapse-header {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-left: 0 !important;
	}
`;

export const SectionTitle = styled.h2`
	font-size: 1.5rem;
	margin-bottom: 0;
	span {
		font-weight: 600;
	}
`;
